import { render } from "./basedate.vue?vue&type=template&id=1ef1416c&scoped=true"
import script from "./basedate.vue?vue&type=script&lang=js"
export * from "./basedate.vue?vue&type=script&lang=js"

import "./basedate.vue?vue&type=style&index=0&id=1ef1416c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ef1416c"]])

export default __exports__